export const CommunicationChannelHelper = {
  EmailAddress: 'EmailAddress',
  MobileLine: 'MobileLine',
  LandLine: 'LandLine',
  FaxLine: 'FaxLine',
  Twitter: 'SMTwitter',
  Facebook: 'SMFacebook',
  LinkedIn: 'SMLinkedIn',
  Website: 'Website'
}